import Routes from "../../utils/routes";

const normaliza = (texto: string) =>
  texto
    .normalize("NFD")
    .replace(/[̀-ͯ]/g, "")
    .toLowerCase();

export const rotaDaNoticia = (titulo?: string | null): string | undefined => {
  const tituloNormalizado = normaliza(titulo || "");
  if (tituloNormalizado.includes("erp") && tituloNormalizado.includes("gestao integrad")) {
    return Routes.centralIntegracao.route;
  }
  return undefined;
};
